import React, { useEffect, useState } from 'react'
import { CuratedSeriesList, CuratedSeriesListProperties } from 'models'
import * as modelProps from 'models/curatedSeriesList/curatedSeriesList-property-definitions'
import { BuildForm, BuildFormArgs } from 'features/build-form'
import utils from 'features/curatedSeriesList/curatedSeriesList-util'
import validations from 'features/curatedSeriesList/curatedSeriesList-validation'

export interface CuratedSeriesListProps {
    BuildList?: (
        page: any,
        name: CuratedSeriesListProperties,
        form: CuratedSeriesList,
    ) => JSX.Element[]
    page?: any
    title?: any
    form?: CuratedSeriesList
    onUpdate?: (form: CuratedSeriesList, valid: boolean, dirty: boolean) => void
    clear?: (callback: () => void) => void
    context?: any
}
export default function CuratedSeriesListForm(props: CuratedSeriesListProps) {
    let [form, setForm] = useState({} as CuratedSeriesList)
    let [dirty, setDirty] = useState({} as any)
    let [hasPosted, setHasPosted] = useState({} as any)
    let [changed, setChanged] = useState(false)
    if (props.clear) {
        props.clear(() => {
            if (changed) {
                setForm({} as CuratedSeriesList)
                setDirty({})
                setHasPosted({})
                setChanged(false)
            }
        })
    }

    useEffect(() => {
        if (changed) {
            setForm({} as CuratedSeriesList)
            setDirty({})
            setHasPosted({})
            setChanged(false)
        }
    }, [props?.context?.id])

    let temp: any = { ...(props.form || {}), ...(form || {}) }
    let args:
        | BuildFormArgs<CuratedSeriesList, CuratedSeriesListProperties>
        | any = {
        ...utils,
        GetPageProperties: () => {
            let properties = utils.GetPageProperties();
            return properties.filter(x => ![
                modelProps.CuratedSeriesListProperties.Id,
                modelProps.CuratedSeriesListProperties.Deleted,
                modelProps.CuratedSeriesListProperties.Version,
                modelProps.CuratedSeriesListProperties.Created,
                modelProps.CuratedSeriesListProperties.Updated,
                modelProps.CuratedSeriesListProperties.Owner,
                modelProps.CuratedSeriesListProperties.ProcessedSeries,
                modelProps.CuratedSeriesListProperties.ReleaseZones,
                modelProps.CuratedSeriesListProperties.Series
            ].includes(x.name))
        },
        form: temp,
        context: props.context,
        utilValidations: validations,
        page: props.page,
        BuildList: (
            page,
            name: CuratedSeriesListProperties,
            form: CuratedSeriesList,
        ) => {
            if (props && props.BuildList) {
                return props.BuildList(page, name, form)
            }
            return []
        },
        setForm: (
            form: CuratedSeriesList,
            property: CuratedSeriesListProperties,
            formValid: boolean,
            updates?: any,
        ) => {
            let newDirty = { ...dirty }
            if (property) {
                newDirty = { ...dirty, [property]: true }
            }
            if (updates) {
                Object.keys(updates).forEach((property) => {
                    newDirty = { ...newDirty, ...dirty, [property]: true }
                })
            }
            setDirty(newDirty)
            let updatedForm: any = {}
            for (let i in newDirty) {
                updatedForm[i] = (form as any)[i]
            }
            setChanged(true)
            setForm(updatedForm)
            if (props.onUpdate) {
                props.onUpdate(
                    { ...(props.form || {}), ...updatedForm },
                    formValid,
                    newDirty,
                )
            }
        },
        isDirty: (property: CuratedSeriesListProperties) => {
            return dirty[property]
        },
        hasPosted: () => hasPosted,
    }
    return (
        <React.Fragment>
            {BuildForm<CuratedSeriesList, CuratedSeriesListProperties>(args)}
        </React.Fragment>
    )
}
